import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { BILLING_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";

type Inclusion = {
  experienceId: number;
  inclusion: {
    id: number;
    invoiceId: number;
    net: number;
    markup: number;
    tax: number;
    billable: boolean;
    ca: number;
    cb: number;
    lma: null | number;
    lmb: null | number;
    total: number;
  };
  inclusionDetails: number;
};

type Result = Array<Inclusion>;
type QueryError = {};

const useInvoiceInclusionsQuery = (
  invoiceId: number | undefined,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const url = `${BILLING_ENDPOINT}/invoices/${invoiceId}/inclusions`;
  const { fetchWithAuth } = useFetchWithAuth();
  const cacheKey = [url, invoiceId];

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!invoiceId) throw new Error();

      const res = await fetchWithAuth<Result>(url);

      return res;
    },
    {
      enabled: !!invoiceId,
      ...options,
    }
  );
};
export default useInvoiceInclusionsQuery;
